import { CreateActionParams } from '../actions';
import { SlotService } from '../../../../utils/state/types';
import { getServiceSlotIdentifier } from '../../../../utils';
import {
  PaymentMethod,
  PaymentOption,
  PaymentType,
  ReservedPaymentOptionLabels,
} from '../../../../types/types';
import { bookingsUouBookingsFormClicks1185 } from '@wix/bi-logger-wixboost-ugc/v2';
import {
  FormClickAction,
  FormClickComponent,
  FormClickActionValue,
} from '../../../../types/biLoggerTypes';
import { ServiceType } from '@wix/ambassador-bookings-services-v2-service/types';

export type setServiceSelectedPaymentOptionType = (
  service: SlotService,
  paymentOption: PaymentOption,
) => void;

export function createSetServiceSelectedPaymentOption({
  context: { biLogger },
  internalActions: { updateServiceSlot, calculatePaymentDetails },
}: CreateActionParams): setServiceSelectedPaymentOptionType {
  return async (service: SlotService, paymentOption: PaymentOption) => {
    let selectedPaymentType: PaymentMethod;
    let formClickActionValue: string = FormClickActionValue.Offline;

    switch (paymentOption.type) {
      case PaymentType.SINGLE_SESSION: {
        if (paymentOption.label === ReservedPaymentOptionLabels.ONLINE) {
          selectedPaymentType = PaymentMethod.ONLINE;
          formClickActionValue = FormClickActionValue.Online;
        } else {
          selectedPaymentType = PaymentMethod.OFFLINE;
          formClickActionValue = FormClickActionValue.Offline;
        }
        break;
      }
      case PaymentType.BUY_PLAN:
      case PaymentType.USE_PLAN: {
        selectedPaymentType = PaymentMethod.MEMBERSHIP;
        formClickActionValue = paymentOption.label;
        break;
      }
      default: {
        selectedPaymentType = PaymentMethod.OFFLINE;
      }
    }

    const shouldResetAddons =
      service.service.type === ServiceType.CLASS ||
      service.service.type === ServiceType.COURSE;

    biLogger?.report(
      bookingsUouBookingsFormClicks1185({
        component: FormClickComponent.Payment,
        action: FormClickAction.ChoosePaymentOption,
        value: formClickActionValue,
        serviceId: service.service.id,
        paymentOptions: JSON.stringify(service.service.paymentTypes),
      }),
    );

    updateServiceSlot(
      {
        selectedPaymentOption: paymentOption,
        selectedPaymentType: selectedPaymentType!,
        ...(shouldResetAddons && { selectedAddons: {} }),
      },
      getServiceSlotIdentifier(service.nestedSlot),
    );

    // Recalculate payment details when payment option changes
    await calculatePaymentDetails({});
  };
}
